import React from 'react'
import { ExternalLink } from '../shared/Links/ExternalLink'
import { InternalLink } from '../shared/Links/InternalLink'
import { MultipleExternalLink } from '../shared/Links/MultipleExternalLink'
import {
  EXTERNAL_LINK,
  MULTIPLE_EXTERNAL_LINK,
  PUCCPAGES_LINK,
  MICROSITE_LINK
} from '../utils/variables/dynamicZoneMainHeader'

const DynamicZoneMainHeader = ({ homeData, matchPages, position }) => {

  const { mainNavbar } = homeData
  
  if (mainNavbar) {
    return mainNavbar.map((component, index) => {
      // switch (component.strapi_component) {
      switch (component.__component) {
        case EXTERNAL_LINK:
          return (
            <ExternalLink
              key={'dynamic-header-' + index}
              data={component}
              icon={component.icon}
              scroll={position}
            />
          )
        case MULTIPLE_EXTERNAL_LINK:
          return (
            <MultipleExternalLink
              key={'dynamic-header-' + index}
              data={component}
              icon={component.icon}
              scroll={position}
            />
          )
        case MICROSITE_LINK:
        case PUCCPAGES_LINK:
          return (
            <InternalLink
              key={'dynamic-header-' + index}
              data={component}
              matchPages={matchPages}
              icon={component.icon}
              scroll={position}
            />
          )
        default:
          return null
      }
    }) 
  } else {
    return null
  }
}

export default DynamicZoneMainHeader
